import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  EventEmitter,
  ElementRef,
  Input,
  Output,
  OnDestroy,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  input,
  inject,
  Injector,
} from "@angular/core";
import { ESCAPE } from "@angular/cdk/keycodes";
import { Subject, fromEvent } from "rxjs";
import { tap, takeUntil } from "rxjs";
import { CalendarBuilder, DateModel } from "@root/component/multi-calendar/multi-calendar.service";

import _ from "lodash";
import * as moment from "moment";
import { Moment } from "moment";
import { Router } from "@angular/router";
import { TranslateService } from "@root/shared/service/translate.service";
import { log } from "@root/util/logger";
import { DateService } from "@root/shared/service/date.service";
import {
  Parent,
  EntityData,
  MultiHouseCalendarService,
  Child,
  DateRange,
  entityType,
} from "./multi-house-calendar.service";
import { toObservable } from "@angular/core/rxjs-interop";

interface ICalendarMap {
  [houseId: string]: {
    [date: string]: any;
  };
}

interface IReservationMap {
  [houseId: string]: any[];

  // deleteSpecifiedReservation?: Function;
}

interface DataOfShortcutPop {
  status: "open" | "close" | "diff" | "past";
  // list?: {
  //   0?: Array<any>;
  //   1?: Array<any>;
  // };
}

interface DataOfEditNotePop {
  id: number; // 房源id
  index: number; // 编辑备注pop所在日期的index，多选时为多选的最后一天的index
  text: string; // 备注内容
  list: Array<string>; // 所有的日期
}

@Component({
  selector: "host-multi-house-calendar",
  templateUrl: "./multi-house-calendar.component.html",
  styleUrls: ["./multi-house-calendar.component.scss"],
})
export class MultiHouseCalendarComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild("gridContainer", { static: false, read: ElementRef })
  calendarContainer: ElementRef;
  // @ViewChild("houseBody") houseBody: ElementRef;
  // @ViewChild("calendarBody", { static: true }) calendarBody: ElementRef;
  // @ViewChild('pagination') pagination: TemplateRef<any>;

  listOfHouses = input<Parent[]>([]);

  @Input() readonly cellWidth = 60;
  @Input() readonly cellHeight = 58;
  @Input() calendarType: "complex" | "simple" = "complex";
  @Input() reservationStyle: "status" | "channel" = "status";
  // @Input() listOfHouses: Parent[] = [];
  @Input() calendarMap: ICalendarMap = {};
  @Input() reservationMap: IReservationMap = {};
  @Input() hourReservationMap = {};
  @Input() taskMap = {};
  @Input() freeHouseCountMap = {};
  @Input() freeHouseCountMapByType = {};
  @Input() housesPriceMap = {};
  @Input() housesOversaleMap = {};
  @Input() housesCleanInfoMap = {};
  @Input() inventoryDiffMap = {};
  @Input() isInternational;
  @Input() displayLeadPrice = false;
  @Input() displayLeadRules = false;
  @Output() onDatesChange = new EventEmitter<[string, string]>();
  @Output() onClickReservation = new EventEmitter<string>();
  @Output() onClickChangeAvailable = new EventEmitter();
  @Output() onClickChangeTab = new EventEmitter<number>();
  @Output() onClickSetHouseTypeInventory = new EventEmitter();
  @Output() onClickSaveEditNote = new EventEmitter();
  @Output() onClickArrangeClean = new EventEmitter();
  @Output() onClickUpdateCleanStatus = new EventEmitter();
  @Output() onCalendarScrollToBottom = new EventEmitter<boolean>();
  @Output() onChangeOrderBelongedHouse = new EventEmitter();
  @Output() onClickExtendStay = new EventEmitter();
  @Output() onClickCreateTask = new EventEmitter();
  // _cursor = 0;
  // datesInViewCount = 20;
  // listOfAllDates: Array<DateModel> = [];
  /** 选中选择框所需要的数据 */
  selectedCellDates: DateRange = {
    head: null,
    last: null,
  };

  selectedRectStyle = null;

  listOfSelectedData: EntityData<entityType, "status"> = {
    id: null,
    // thirdparty: null,

    type: "house",
    payload: null,
  };
  /** 选中的入住单 */
  selectedReservationCode = null;
  /** 选中的入住单关联的订单 */
  selectedReservationOrderCode = null;
  /** 房间的快捷气泡数据 */
  dataOfShortcutPop: DataOfShortcutPop = {
    status: "open",
    // list: {}
  };

  dataOfEditNotePop: DataOfEditNotePop = {
    id: null,
    index: null,
    text: null,
    list: null,
  };

  displayEditNotePop = false;
  selectStatus: "none" | "doing" | "done" = "none";

  changeOrderBelongedHouseStatus: "selecting" | "none" = "none";
  changeOrderBelongedHouseData = null;
  changeOrderBelongedHouseRectStyle = null;
  changeOrderBelongedHouseConflictMap = null;

  // private resize$ = this.indexService.resizeRaw$.pipe(
  //   debounceTime(500),
  //   tap(() => {
  //     // this.recalculateDatesInViewCount();
  //     if (this.calendarBody) {
  //       this.checkIfScrollToBottom(this.calendarBody.nativeElement);
  //     }
  //   }),
  // );

  private select$ = this.houseCalendarService.selectRaw$.pipe(
    tap((value) => {
      const { head, last } = value.dates;
      const status = value.status;
      // const headIndex = this.calendarService.offsetStart(head);
      // const lastIndex = this.calendarService.offsetStart(last);

      this.selectStatus = status;
      this.selectedCellDates = {
        head,
        last,
        // headIndex, lastIndex
      };
      this.listOfSelectedData = value.data;

      // if (value.data?.type === "house") {
      //   this.displayShortcutPop = true;
      // }
      this.setSelectedRectStyle();
    }),
  );

  private selectReservation$ = this.houseCalendarService.selectReservationRaw$.pipe(
    tap((value) => {
      this.selectedReservationCode = value;
      const reservation = this.getReservationByCode(value);

      if (reservation && reservation.__reservationCount > 1) {
        this.selectedReservationOrderCode = reservation.__orderCode;
      } else {
        this.selectedReservationOrderCode = null;
      }
      log(
        "currentReservation: ",
        reservation,
        " selectedReservationRelatedReservations: ",
        this.selectedReservationOrderCode,
      );
    }),
  );

  // private scroll$ = this.houseCalendarService.scrollRaw$.pipe(
  //   tap((value) => {
  //     if (_.isNumber(value)) {
  //       this.scroll(value as number);
  //     } else if (value === "L") {
  //       this.scrollByDistance(this.calendarContainer.nativeElement.offsetWidth - 220 - this.cellWidth);
  //     } else if (value === "R") {
  //       this.scrollByDistance(-(this.calendarContainer.nativeElement.offsetWidth - 220 - this.cellWidth));
  //     } else {
  //       // 字符串或者moment型的日期

  //       this.scroll(this.calendarService.offsetStart(value as string));
  //     }
  //     // this.calendarContainer.nativeElement.scrollLeft = left;
  //   }),
  // );
  // private international$ = this.international.onInternationalChange.pipe(
  //   tap(value => {
  //     this.isInternational = value;
  //   })
  // );

  private changeOrderBelongedHouse$ = this.houseCalendarService.changeOrderBelongedHouseRaw$.pipe(
    tap((value) => {
      if (value.action === "Select") {
        this.changeOrderBelongedHouseStatus = "selecting";

        const payload = value.payload;

        const left = payload.index * this.cellWidth + 2;
        const width = payload.width * this.cellWidth - 4;

        this.changeOrderBelongedHouseData = payload;
        this.changeOrderBelongedHouseRectStyle = { left, width };

        this.collectChangeOrderBelongedHouseConflictMap();
      } else {
        this.changeOrderBelongedHouseStatus = "none";
      }
      log("[change order]", value);
    }),
  );

  // private dateFormatChange$ = this.dateService.dateFormatChange$.pipe(
  //   tap(() => {
  //     /** TODO: 逻辑整理 */

  //     this.listOfAllDates = this.calendarService.buildDefaultCalendar();
  //   }),
  // );

  private destroy$ = new Subject();

  injector = inject(Injector);

  // listOfDatesInView: Array<DateModel> = this.listOfAllDates.slice(this.cursor, this.cursor + this.datesInViewCount);

  // get cursor() {
  //   return this._cursor;
  // }

  // set cursor(value) {
  //   /**
  //    * 绑定计算值是一件值得特别关注的事情
  //    * 相比计算listOfDatesInView，计算cursor的计算次数会更少
  //    * 对于要求性能优先的页面来说这点非常重要
  //    *
  //    * 另外一定要注意的是，不要在计算函数里面包含任何的副作用
  //    */
  //   if (value !== this._cursor) {
  //     this._cursor = value;
  //     this.listOfDatesInView = this.listOfAllDates.slice(this.cursor, this.cursor + this.datesInViewCount);
  //   }
  // }

  trackDate = (index, date: DateModel) => date.date;
  trackByReservation = (index, reservation) => reservation.code;
  trackByHouse = (index, house) => house.id;
  trackByHouseType = (index, type) => type.house_type_id;

  constructor(
    private calendarService: CalendarBuilder,
    private houseCalendarService: MultiHouseCalendarService,
    private translate: TranslateService,
    private dateService: DateService,
    public router: Router,
    private elementRef: ElementRef,
    private cdr: ChangeDetectorRef,
  ) {
    // this.listOfAllDates = this.calendarService.buildDefaultCalendar();
  }

  ngOnInit() {
    // this.listOfAllDates = this.calendarService.buildDefaultCalendar();
    // this.dateFormatChange$.pipe(takeUntil(this.destroy$)).subscribe();
    // this.cursor$.pipe(takeUntil(this.destroy$)).subscribe(value => {});
    // this.resize$.pipe(takeUntil(this.destroy$)).subscribe((event) => {
    //   log("resize$");
    //   this._changeDate();
    // });
    this.select$.pipe(takeUntil(this.destroy$)).subscribe((result) => {});

    this.selectReservation$.pipe(takeUntil(this.destroy$)).subscribe();

    // this.scroll$.pipe(takeUntil(this.destroy$)).subscribe();

    this.changeOrderBelongedHouse$.pipe(takeUntil(this.destroy$)).subscribe();
    // this.international$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  ngAfterViewInit() {
    toObservable(this.listOfHouses, { injector: this.injector }).subscribe(() => {
      console.log("list of houses chang");
      this.checkIfScrollToBottom();
    });
    /**
     * TODO: 解决scroll延迟触发的问题
     * question: 在刷新页面的时候，如果页面不可见，scroll事件不会触发，只* 有当页面重新可见的时候才会开始触发
     */
    // console.log("calendarContaienr: ", this.calendarContainer);

    // let scrollTimer;
    // fromEvent(this.calendarContainer.nativeElement, "scroll")
    //   .pipe(
    //     tap((event: Event) => {
    //       console.log("grid container scroll ...");
    //       // clearTimeout(scrollTimer);
    //       // scrollTimer = setTimeout(() => {
    //       //   const scrollLeft = Math.ceil((event.target as HTMLElement).scrollLeft);
    //       //   const cursor = Math.floor(scrollLeft / this.cellWidth);

    //       //   if (cursor !== this.cursor) {
    //       //     // 左右滚动
    //       //     this.cursor = cursor;
    //       //     this._changeDate();
    //       //     this.tmpStickyResvInfo(scrollLeft);
    //       //   } else {
    //       //     // 上下滚动
    //       //     const target = event.target as HTMLElement;
    //       //     this.checkIfScrollToBottom(target);
    //       //   }

    //       //   /**
    //       //    * 4.0.3暂时添加
    //       //    * @TODO 优化逻辑
    //       //    */
    //       //   this.tmpCalculateIsFirstDayInView(scrollLeft);
    //       // }, 100);
    //     }),
    //     // debounceTime(300),
    //     takeUntil(this.destroy$),
    //   )
    //   .subscribe((event: Event) => {});

    fromEvent(document, "keyup")
      .pipe(
        tap((e: KeyboardEvent) => {
          if (e.keyCode === ESCAPE) {
            this.endChangeOrderBelongedHouse();
          }
        }),
        takeUntil(this.destroy$),
      )
      .subscribe();

    /** fix: ExpressionChangedAfterItHasBeenCheckedError */
    // let timer = setTimeout(() => {
    //   this.recalculateDatesInViewCount();
    //   this.scroll(363);

    //   clearTimeout(timer);
    //   timer = null;
    // });
  }

  ngOnChanges(change: SimpleChanges) {
    if (
      this.changeOrderBelongedHouseStatus === "selecting" &&
      change["reservationMap"] &&
      change["reservationMap"].currentValue
    ) {
      this.collectChangeOrderBelongedHouseConflictMap();
    }
  }

  // private tmpCalculateIsFirstDayInView(scrollLeft: number) {
  //   this.listOfDatesInView.forEach((item) => (item["isFirstDayInView"] = false));
  //   if (this.listOfDatesInView[0]?.offsetStart * this.cellWidth < scrollLeft) {
  //     this.listOfDatesInView[0]["isFirstDayInView"] = false;
  //     this.listOfDatesInView[1]["isFirstDayInView"] = true;
  //   } else {
  //     this.listOfDatesInView[0]["isFirstDayInView"] = true;
  //   }
  // }

  private tmpStickyResvInfo() {
    const scrollLeft = this.calendarContainer.nativeElement.querySelector(".grid-container").scrollLeft;

    const host = this.elementRef.nativeElement;
    const resvs = host.querySelectorAll(".host-reservation-bar");

    resvs?.forEach((resv: HTMLDivElement) => {
      const nights = resv.clientWidth / this.cellWidth;
      // console.log('resv.left: ', resv.offsetLeft);
      /** 只处理大于 4 晚的订单 */
      if (nights >= 4) {
        const child = resv.querySelector(".inner-content") as HTMLElement;
        if (scrollLeft > resv.offsetLeft && scrollLeft <= resv.offsetLeft + resv.clientWidth) {
          const diff = scrollLeft - resv.offsetLeft;
          child.style.transform = `translateX(${diff}px)`;
        } else {
          child.style.transform = "translateX(0)";
        }
      }
    });
  }

  /** 根据入住单号找到该入住单对应的订单 */
  private getReservationByCode(code) {
    let result = null;
    _.forOwn(this.reservationMap, (houseMap) => {
      if (result) {
        return false;
      }
      _.forOwn(houseMap, (reservation) => {
        if (code === reservation.__code) {
          result = reservation;
          return false;
        }
      });
    });
    return result;
  }

  /** 订单换房房间的冲突情况，即房间与所选订单的日期是否存在冲突 */
  collectChangeOrderBelongedHouseConflictMap() {
    const { index, width, code } = this.changeOrderBelongedHouseData;
    const conflict = (aIdx, aWidth, bIdx, bWidth) =>
      (_.inRange(bIdx, aIdx, aIdx + aWidth) || _.inRange(aIdx, bIdx, bIdx + bWidth)) &&
      (aIdx !== bIdx || aWidth !== bWidth);

    const result = {};
    _.forEach(this.reservationMap, (rs, hId) => {
      const isConflict = _.some(rs, (res) => conflict(res.__index, res.__nights, index, width));
      if (isConflict) {
        result[hId] = true;
      } else {
        result[hId] = false;
      }
    });

    this.changeOrderBelongedHouseConflictMap = result;
    log("chanage order belonged house conflict map: ", this.changeOrderBelongedHouseConflictMap);
  }

  onClickCell(house: Child, date) {
    // log('onClickCell: ', house);
    const dateStr = date.date;
    const calendar = _.get(this.calendarMap, [house.c_id, dateStr]);
    if (calendar && calendar.reservation) {
      return;
    }
    if (this.selectStatus === "none" || this.selectStatus === "done") {
      this.displayEditNotePop = false;

      this.selectStatus = "doing";

      this._select(
        {
          // id: house.id,
          head: date.value,
          last: date.value,
        },
        {
          id: house.c_id,
          house: house,
          // 以上废弃
          type: "house",
          payload: house,
        },
      );
    } else {
      // this.selectStatus = 'done';
      // const data = this.listOfSelectedDates;
      const data = this.listOfSelectedData;
      const date = this.selectedCellDates;

      const { id, type } = data;

      if (type === "type") {
        // this.onClickTypeCell(house, date);
        return;
      }

      this.selectStatus = "done";

      /** 结束托选后，需要排一下序，防止反向托选时head大于last */
      const [head, last] = [moment.min(date.head, date.last), moment.max(date.head, date.last)];

      /** 更新气泡数据 */
      const calendar = this.calendarMap[id] || {};
      const sliced = _.filter(calendar, (c) => head.isSameOrBefore(c.date, "d") && last.isSameOrAfter(c.date, "d"));
      this.updateDataOfShortcutPop(sliced);
      this.updateDataOfEditNotePop(sliced);

      this._select(
        {
          head,
          last,
          // house
        },
        this.listOfSelectedData,
      );

      // this.scrollIntoView();
    }
  }

  onHoverCell(house: Child, date: DateModel) {
    if (this.selectStatus !== "doing") {
      return;
    }

    const { head, last: previousLast } = this.selectedCellDates;
    const { id } = this.listOfSelectedData;
    const currentLast = date.value;

    /** 鼠标移动到其他房源 */
    if (house.c_id !== id) {
      return;
    }

    /**
     * 查看所选日期之内是否有订单
     * 这里的顺序是：先检查是否有订单，再判断日期是否在所选区间
     * 相比反过来的顺序，这种方式可以显著的减少遍历的次数
     */
    let hasReservation = false;
    _.forOwn(this.calendarMap[house.c_id], (value, key) => {
      if (value.reservation) {
        if (this.isBetween(moment(value.date), head, currentLast)) {
          hasReservation = true;
          return false;
        }
      }
    });

    /**
     * 区间有订单，则last保持上一次的值不变，因为值没变，所以不需要更新选择的样式
     * 区间没有订单，更新last值，更新选择的样式
     */
    if (!hasReservation) {
      this._select(
        {
          ...this.selectedCellDates,
          last: currentLast,
        },
        this.listOfSelectedData,
      );
    }

    // if (this.detectAtCalendarEdge(date)) {
    //   this.scrollIntoView();
    // }
    // this.calendarEdgeDetection(date);
  }

  onClickTypeCell(type: Parent, date: DateModel) {
    log("onClickTypeCell: ", type, date);
    /** 独立房间不允许点击 */
    if (type.p_id === -1) {
      return;
    }

    if (this.selectStatus === "none" || this.selectStatus === "done") {
      this.selectStatus = "doing";
      this._select(
        {
          // id: type.house_type_id,
          head: date.value,
          last: date.value,
          // type: 'type',
        },
        {
          id: type.p_id,
          houseType: {
            id: type.p_id,
            title: type.p_title,
          },
          // 以上废弃
          type: "type",
          payload: type,
        },
      );
    } else {
      // this.selectStatus = 'done';
      const date = this.selectedCellDates;
      const data = this.listOfSelectedData;

      const { id, type } = data;
      if (type === "house") {
        // this.onClickCell(type, date);
        return;
      }
      this.selectStatus = "done";
      /** 结束托选后，需要排一下序，防止反向托选时head大于last */
      const [head, last] = [moment.min(date.head, date.last), moment.max(date.head, date.last)];
      this._select(
        {
          head,
          last,
          // type: 'type'
        },
        this.listOfSelectedData,
      );
    }
  }

  onHoverTypeCell(type: Parent, date: DateModel) {
    if (this.selectStatus !== "doing") {
      return;
    }

    const { id } = this.listOfSelectedData;
    const currentLast = date.value;

    if (type.p_id !== id) {
      return;
    }

    this._select(
      {
        ...this.selectedCellDates,
        last: currentLast,
      },
      this.listOfSelectedData,
    );
  }

  onClickHourOrder(event, orders: Array<any>, date) {
    event.stopPropagation();

    if (moment().isAfter(date, "d")) {
      const code = _.get(_.last(orders), "code");
      this._selectReservation(code);
    } else if (moment().isBefore(date, "d")) {
      const code = _.get(_.head(orders), "code");
      this._selectReservation(code);
    } else {
      let min = Infinity;
      let code;
      orders.forEach((order) => {
        const diff = moment().diff(`${order.check_in} ${order.start_time}`, "m");
        if (diff < min) {
          min = diff;
          code = order.code;
        }
      });
      this._selectReservation(code);
    }
  }

  onClickTask(event, tasks) {
    event.stopPropagation();
    const task = _.head(tasks);
    this._selectTask(task);
    // this._selectTask({
    //   taskId: task.id,
    //   houseId: task.house_id,
    //   date: task.expected_date,
    //   type: task.type,
    // });
    // this._selectTask(task.id, task.expected_date);
    console.log("task: ", tasks);
  }

  isHourReservationSelected(houseId, date) {
    if (!this.selectedReservationCode) {
      return false;
    }

    const orders = _.get(this.hourReservationMap, [houseId, date]);
    if (!orders) {
      return false;
    }

    return _.find(orders, (order) => order.code === this.selectedReservationCode);
  }

  isBetween(date: Moment, head, last) {
    // const { head, last, id } = this.listOfSelectedDates;
    if (!head && !last) {
      return;
    }
    // log('here');
    const [_head, _last] = [moment.min(head, last), moment.max(head, last)];

    return date.isSameOrAfter(_head, "d") && date.isSameOrBefore(_last, "d");
  }

  getFreeHouseCount(date) {
    const count = _.get(this.freeHouseCountMap, [date, "can_sell"]);
    const result = count || count === 0 ? count : "-";
    if (this.isInternational) {
      return result;
    }

    return "余" + result;
  }

  getFreeHouseCountByType(type, date) {
    const count = _.get(this.freeHouseCountMapByType, [type, date]);
    return count || count === 0 ? count : "-";
  }

  updateDataOfShortcutPop(calendars = []) {
    console.log("calendars: ", calendars);

    let status: "open" | "close" | "diff" | "past" = "open";

    const head = _.head(calendars);

    const isPast = moment().isAfter(head.date, "d");

    if (isPast) {
      this.dataOfShortcutPop = { status: "past" };
      return;
    }

    if (calendars.length === 1) {
      /**
       * 单天分为 打开  关闭  不一致三种状态
       * 其中不一致状态需要显示具体不一致的渠道信息
       */
      const calendar = _.head(calendars) || {};
      if (calendar.available === 0) {
        status = "close";
      } else if (calendar.available === 1) {
        status = "open";
      } else {
        status = "diff";

        // list = _.groupBy(calendar.housing_status, "available");
      }
    } else {
      /**
       * 多天分为 打开  关闭  不一致三种状态
       * 不一致状态不需要显示具体渠道信息
       */
      if (_.every(calendars, (calendar) => calendar.available === 0)) {
        status = "close";
      } else if (_.every(calendars, (calendar) => calendar.available === 1)) {
        status = "open";
      } else {
        status = "diff";
      }
    }

    this.dataOfShortcutPop = { status };
    // log("dataOfSelectedDates: ", this.dataOfShortcutPop);
  }

  updateDataOfEditNotePop(calendars = []) {
    console.log("calendars: ", calendars);
    let id, index, text;

    const list = _.map(calendars, "date");

    const first = _.head(calendars);
    const last = _.last(calendars);
    if (calendars.length === 1) {
      id = first.house_id;
      index = this.calendarService.offsetStart(first.date);
      text = first.note;
    } else {
      const note = first.note;

      id = first.house_id;
      index = this.calendarService.offsetStart(last.date);
      text = _.every(calendars, (c) => c.note === note) ? note : "";
    }

    this.dataOfEditNotePop = { id, index, text, list };
    console.log("data of edit note pop: ", this.dataOfEditNotePop);
  }

  // detectAtCalendarEdge(date: DateModel): boolean {
  //   const lastDates = _.takeRight(this.listOfDatesInView, 2);
  //   return !!_.find(lastDates, (d) => d.date === date.date);
  // }

  setSelectedRectStyle() {
    const head = this.selectedCellDates.head;
    const last = this.selectedCellDates.last;

    const headIdx = this.calendarService.offsetStart(head);
    const lastIdx = this.calendarService.offsetStart(last);

    const left = Math.min(headIdx, lastIdx) * this.cellWidth;
    const width = (Math.abs(lastIdx - headIdx) + 1) * this.cellWidth;
    this.selectedRectStyle = { left, width };
  }

  startChangeOrderBelongedHouse(order) {
    log("order: ", order);
    this.houseCalendarService.changeOrderBelongedHouseRaw$.next({
      action: "Select",
      payload: {
        code: order.code,
        index: order.__index,
        width: order.__nights,
        houseId: order.house_id,
      },
    });

    this.houseCalendarService.cancelSelectReservation();
  }

  endChangeOrderBelongedHouse() {
    this.houseCalendarService.changeOrderBelongedHouseRaw$.next({
      action: "Cancel",
      payload: {},
    });
  }

  extendStayForReservation(code) {
    this.onClickExtendStay.emit(code);
  }

  createTask(event, date, houseId) {
    this.onClickCreateTask.emit({ date, houseId });
  }

  // scrollIntoView() {
  //   const padding = 2; // 额外滚动的天数
  //   const sidebarWidth = 392;

  //   const sidebarLengthOfDays = Math.ceil(sidebarWidth / this.cellWidth); // 侧边栏占用的天数
  //   const selectedLast = this.selectedCellDates.last;
  //   const rangeLast = _.last(this.listOfDatesInView).date;

  //   const offsetLengthOfDays = moment(rangeLast).diff(selectedLast, "d"); // 选择的最后一天与屏幕的最后一天的差距，单位：天

  //   if (offsetLengthOfDays <= sidebarLengthOfDays) {
  //     this.scroll(this.cursor + (sidebarLengthOfDays - offsetLengthOfDays) + padding);
  //   }
  // }

  // /**
  //  * 滚动到指定日期
  //  * @public
  //  * @params cursor 日期的索引
  //  */
  // scroll(cursor: number) {
  //   console.log("calendarContainer: ", this.calendarContainer);
  //   this.calendarContainer.nativeElement.scrollLeft = cursor * this.cellWidth;
  // }

  // /**
  //  * 滚动到指定位置
  //  * @params position 要滚动的位置
  //  */
  // scrollToPosition(position: number) {
  //   this.calendarContainer.nativeElement.scrollLeft = position;
  // }

  // /**
  //  * 滚动指定距离
  //  * @params position 要滚动的距离
  //  */
  // scrollByDistance(distance: number) {
  //   const currentLeft = this.calendarContainer.nativeElement.scrollLeft;
  //   this.calendarContainer.nativeElement.scrollLeft = currentLeft - distance;
  // }

  checkIfScrollToBottom() {
    const target = this.calendarContainer.nativeElement.querySelector(".grid-container");

    if (target.clientHeight + target.scrollTop + 14 >= target.scrollHeight) {
      console.log("list of house scroll to bottom: ", true);
      this.onCalendarScrollToBottom.emit(true);
      // this.displayPagination();
    } else {
      console.log("list of house scroll to bottom: ", false);
      this.onCalendarScrollToBottom.emit(false);
      // this.dismissPagination();
    }
  }

  // recalculateDatesInViewCount() {
  //   /**
  //    * calendarContainer的宽度是固定的，datesInViewCount也是固定的
  //    * 因此在某种情况下（即滑动日历，第一个cell的右边界没有完全到达calendarContainer的左边界时）
  //    * 此时拉伸浏览器窗口时，如果拉伸的宽度小于cellWidth，会导致最右端的cell无法渲染出来而出现一格的空白。故在此加1以修正这种情况。
  //    */
  //   this.datesInViewCount = Math.ceil(this.calendarContainer.nativeElement.offsetWidth / this.cellWidth) + 1;
  // }

  changeHouseAvailable(status: 0 | 1) {
    const { head, last } = this.selectedCellDates;
    const { id } = this.listOfSelectedData;

    this.onClickChangeAvailable.emit({
      id,
      head: moment(head).format("YYYY-MM-DD"),
      last: moment(last).format("YYYY-MM-DD"),
      status,
    });
    this.houseCalendarService.cancelSelect();
  }

  onSaveEditNote(note) {
    const { id, list } = this.dataOfEditNotePop;
    this.onClickSaveEditNote.emit({
      house_id: id,
      date_list: JSON.stringify(list),
      note,
    });

    this.onCancelEditNote();
  }

  onCancelEditNote() {
    this.displayEditNotePop = false;
    this.houseCalendarService.cancelSelect();
  }

  onHorizontalScroll(dates: [string, string]) {
    this.onDatesChange.emit(dates);

    this.tmpStickyResvInfo();
  }

  changeOrderBelongedHouse(houseId) {
    const params = {
      house_id: houseId,
      reservation_code: this.changeOrderBelongedHouseData.code,
    };
    this.onChangeOrderBelongedHouse.emit(params);

    this.endChangeOrderBelongedHouse();
  }

  toPropertyDetailPage(params) {
    this.router.navigate(["/app/properties"]);

    setTimeout(() => {
      this.router.navigate(["/app/properties/detail"], params);
      // this.zone.run(() => {
      // });
    }, 200);
  }

  _displayHourReservationSidebar(data: EntityData<"house", "status">, date) {
    const entity = data.payload;
    const param = {
      // house: data.house,
      house: {
        id: entity.c_id,
        house_title: entity.c_title,
      },
      date: date.head,
    };
    log("param: ", param);
    this.houseCalendarService.displayHourReservationSidebar(param);
  }

  _changeTab(index) {
    this.onClickChangeTab.emit(index);
    // this.displayShortcutPop = false;
  }

  _setHouseTypeInventory(houseTypeId) {
    const { head, last } = this.selectedCellDates;
    const params = {
      house_type_id: houseTypeId,
      begin: head.format("YYYY-MM-DD"),
      end: last.format("YYYY-MM-DD"),
    };
    this.onClickSetHouseTypeInventory.emit(params);
    this.houseCalendarService.cancelSelect();
  }

  // _changeDate() {
  //   const beginCursor = this.cursor;
  //   const endCursor =
  //     this.cursor + this.datesInViewCount >= this.listOfAllDates.length
  //       ? this.listOfAllDates.length - 1
  //       : this.cursor + this.datesInViewCount;
  //   this.houseCalendarService.dateChangeRaw$.next([
  //     _.get(this.listOfAllDates[beginCursor], "date"),
  //     _.get(this.listOfAllDates[endCursor], "date"),
  //   ]);
  // }

  _select(value, data = {}) {
    console.log("_select: value: ", value, " data: ", data);
    this.houseCalendarService.select({
      status: this.selectStatus,
      dates: value,
      data,
    });
  }

  _selectReservation(code) {
    this.houseCalendarService.selectReservation(code);
  }

  _selectTask(data) {
    this.houseCalendarService.selectTask(data);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
